import {ActivatedRoute} from '@angular/router';
import {Component, OnInit} from '@angular/core';
import {LoadingService} from '../services/loading.service';

@Component({
  styleUrls: ['./error.component.scss'],
  templateUrl: './error.component.html'
})
export class ErrorComponent implements OnInit {
  public icon: string;
  public height: number;
  public message: string;

  constructor(private activatedRoute: ActivatedRoute,
              private loadingService: LoadingService) {
    this.loadingService.hide();

    this.height = window.innerHeight - 96;
  }

  public ngOnInit(): void {
    this.activatedRoute.data.subscribe((data) => {
      if (data.mode === 'access-denied') {
        this.icon = 'report_problem';

        this.message = 'Δεν έχετε δικαίωμα πρόσβασης σ\' αυτή τη σελίδα';
      } else {
        this.icon = 'report';

        this.message = 'Δεν υπάρχει η σελίδα που αναζητήσατε.';
      }
    });
  }
}
